import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ICouponFilterButton } from '@pages/coupons/interfaces';

const FilterButton: React.FC<ICouponFilterButton> = ({ icon, filtersDirty, onClick }) => {
    return (
        <button
            className="relative ml-4 bg-white border border-[#f2f2f2] box-border shadow-5 rounded-2 w-[56px] h-[48px]"
            type="button"
            id="CouponsMobileFilterToggleButton"
            onClick={onClick}
        >
            <FontAwesomeIcon icon={icon} />
            {filtersDirty && (
                <span className="absolute inline-block w-4 h-4 bg-red-500 border-4 border-white rounded-full right-2 top-1.5" />
            )}
        </button>
    );
};

export default FilterButton;
